// MenuBar.tsx
import React from 'react';
import { Editor } from '@tiptap/react';
import useMenuBarState from '../hooks/ui/useMenuBarState';
import { Button, ButtonGroup, ButtonToolbar } from './ui';

interface MenuBarProps {
  editor: Editor | null;
}

const MenuBar: React.FC<MenuBarProps> = ({ editor }) => {
  const {
    canBold,
    canItalic,
    canBulletList,
    canOrderedList,
  } = useMenuBarState(editor);

  if (!editor) return null;

  return (
    <ButtonToolbar marginBottom={1}>
      <ButtonGroup marginEnd={2} marginBottom={1}>
        <Button
          type="button"
          onClick={() => editor.chain().focus().toggleBold().run()}
          disabled={!canBold}
          variant="secondary"
          outline
          size="sm"
          active={editor.isActive('bold')}
        >
          Gras
        </Button>
        <Button
          type="button"
          onClick={() => editor.chain().focus().toggleItalic().run()}
          disabled={!canItalic}
          variant="secondary"
          outline
          size="sm"
          active={editor.isActive('italic')}
        >
          Italique
        </Button>
      </ButtonGroup>
      <ButtonGroup marginBottom={1}>
        <Button
          type="button"
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          disabled={!canBulletList}
          variant="secondary"
          outline
          size="sm"
          active={editor.isActive('bulletList')}
        >
          Liste
        </Button>
        <Button
          type="button"
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          disabled={!canOrderedList}
          variant="secondary"
          outline
          size="sm"
          active={editor.isActive('orderedList')}
        >
          Liste num.
        </Button>
      </ButtonGroup>
    </ButtonToolbar>
  );
};

export default MenuBar;
